<template>
  <DataList
    title="Користувачі"
    resource="users"
    :columns="columns"
    :page-size="9"
    :get-items-fn="getUsers"
    :filter="filter"
    :search-label="'Пошук за поданням'"
  >
    <template v-slot:filters>
      <v-row dense>
        <v-col cols="5">
          <UserRolesSelect v-model="filter.role" />
        </v-col>
      </v-row>
    </template>
  </DataList>
</template>

<script>
import * as usersApi from "../../../backend/usersApi.js";
import UserRolesSelect from "../../../components/enums/UserRoleSelect.vue";

export default {
  components: {
    UserRolesSelect,
  },
  data: () => ({
    filter: { role: null },
    columns: [
      { title: "id", name: "id" },
      { title: "Логін", name: "name" },
      { title: "Подання", name: "title" },
      { title: "Email", name: "email" },
      { title: "Коментарій", name: "comment" },
      { title: "Роль", name: "role", component: "UserRolesLabel" },
    ],
  }),
  methods: {
    getUsers(...args) {
      return usersApi.getUsers(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
